/**
 * Prest0nRuntime constants.
 */

/** Account IDs that have been migrated to the Prest0nRuntime path. */
export const MIGRATED_ACCOUNT_IDS: Set<string> = new Set([
  // Phase 1 migrated accounts only
  'zmoa6mrnzBaI5s2lzR4dlFM0qA02', // Fernando Hidalgo Firebase UID (direct legacy path)
  'fernando-hidalgo',              // Fernando Hidalgo canonical accountId (post-membership resolution)
  // 'kFZ5…' legacy Prest0 testing account removed 2026-08-17 (owner-approved
  // deletion, account/org/VM cleanup-sweep plan) — it now resolves through the
  // ordinary config-doc gate until the account itself is purged.
]);

/** Current version of the Prest0nRuntime abstraction layer. */
export const PREST0N_RUNTIME_VERSION = '1.0.0';

/** Firestore collection prefix for account documents. */
export const ACCOUNT_FIRESTORE_PREFIX = 'accounts';

/** Firestore path for core system configuration. */
export const CORE_FIRESTORE_PREFIX = 'system/prest0Core';

/**
 * Per-account VM migration rollback toggle.
 *
 * To disable VM routing for an account without a code deploy, set the following
 * fields in Firestore:
 *   accounts/{accountId}/config/runtime.migrationEnabled = false   (disables prest0n runtime path)
 *   accounts/{accountId}/vm/main.enabled = false                   (disables VM proxy in CF router)
 *
 * To disable ALL accounts at once (emergency kill switch), set:
 *   system/prest0Core/config.vmRoutingEnabled = false
 *
 * To re-enable, reverse the above. No code deploy required for Firestore-based toggles.
 */
export const VM_ROUTING_ROLLBACK_INSTRUCTIONS = {
  perAccount: 'Set accounts/{accountId}/config/runtime.migrationEnabled=false',
  emergency: 'Set system/prest0Core/config.vmRoutingEnabled=false',
  fallback: 'shared-worker',
} as const;
